import type React from 'react';
import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import { PageLoading } from '@/app/components/page-loading.tsx';

const LazyCalendar = lazy(() => import('./Calendar'));

const Calendar = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => {
  return (
    <Suspense fallback={<PageLoading />}>
      <LazyCalendar {...props} />
    </Suspense>
  );
};

export const calendarRoute = {
  path: '/calendar/:accountKey?',
  element: <Calendar />,
} as RouteObject;
export default Calendar;
